import { combineReducers, configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import authReducer, { AuthState } from './reducers/auth.reducer';
import dashboardReducer, { DashboardState } from './reducers/dashboard.reducer';
import externalUserReducer, {
  ExternalUserState,
} from './reducers/externalUser.reducer';
import faultReducer, { FaultState } from './reducers/fault.reducer';
import intelligenceSolutionReducer, {
  IntelligenceSolutionState,
} from './reducers/intelligenceSolution.reducer';
import privilegesReducer, {
  PrivilegeState,
} from './reducers/privilege.reducer';
import usageSummaryPageReducer, {
  UsageSummaryPageState,
} from './reducers/usageSummaryPage.ruducer';

const middleware = [thunk];

export interface IRootState {
  readonly auth: AuthState;
  readonly privileges: PrivilegeState;
  readonly intelligenceSolution: IntelligenceSolutionState;
  readonly fault: FaultState;
  readonly externalUser: ExternalUserState;
  readonly dashboard: DashboardState;
  readonly usageSummaryPage: UsageSummaryPageState;
}

const rootReducer = combineReducers<IRootState>({
  auth: authReducer,
  privileges: privilegesReducer,
  intelligenceSolution: intelligenceSolutionReducer,
  fault: faultReducer,
  externalUser: externalUserReducer,
  dashboard: dashboardReducer,
  usageSummaryPage: usageSummaryPageReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware,
});

export default store;
